import React from 'react';
import { useTranslation } from 'react-i18next';
import Info from './Info';
import { MainWrapper, MainWrapperContainer } from './styles';
import Picture from './Picture';

function Main({ posting, status, openDetailPosting, isDraft, isParticular }) {
  const { t } = useTranslation();
  const {
    urlPicture,
    postingLocation,
    pricesOperationTypes,
    title,
    realEstateType,
    performanceStatus,
    publicationType,
    isExclusiveZone
  } = posting;
  const { address } = postingLocation[0] || { address: '', zone: '', city: '' };

  return (
    <MainWrapperContainer>
      <MainWrapper>
        <div className='picture-layout'>
          <Picture urlPicture={urlPicture} openDetailPosting={openDetailPosting} />
        </div>
        <Info
          propertyType={realEstateType}
          title={title}
          address={address}
          pricesOperationTypes={pricesOperationTypes}
          status={status}
          performanceStatus={performanceStatus}
          openDetailPosting={openDetailPosting}
          isDraft={isDraft}
          publicationType={publicationType}
          isExclusiveZone={isExclusiveZone}
        />
      </MainWrapper>
    </MainWrapperContainer>
  );
}

export default Main;
